import React, { Component } from "react";
import { getHighlightText } from "./postInfoUtils";
import ParentPost from "./ParentPost";
import "./PostContent.scss";

class PostContent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div
                className={`post-content-container ${this.props.dashboardPageType !== "SMP" ? "bottom__border" : ""}  ${
                    this.props.listView ? "post-content-container-listView" : ""
                }`}>
                <div className="post-content">
                    {this.props.data.postTitle && this.props.data.platformName !== "Twitter" && (
                        <div
                            className="post-title"
                            dangerouslySetInnerHTML={{
                                __html: getHighlightText(
                                    this.props.data.postTitle,
                                    this.props.customQuery,
                                    this.props.data.productAttributes,
                                    this.props.data.platformName,
                                ),
                            }}
                        />
                    )}
                    <div
                        className="post-content-data"
                        dangerouslySetInnerHTML={{
                            __html: getHighlightText(
                                this.props.data.post,
                                this.props.customQuery,
                                this.props.data.productAttributes,
                                this.props.data.platformName,
                            ),
                        }}
                    />

                    {this.props.data.postTitle && this.props.data.platformName === "Twitter" && <div className="post-title">{this.props.data.postTitle}</div>}
                </div>
                {this.props.data.hasParentPost && (
                    <ParentPost
                        data={this.props.postData}
                        customQuery={this.props.customQuery}
                        platformName={this.props.data.platformName}
                        listView={this.props.listView}
                    />
                )}
            </div>
        );
    }
}

export default PostContent;
